import type { BankTransferResult, BankTransferResultFormValues } from "../types"
import {
  toDateTimeInputValue,
  toDateTimeOrNull,
  toInputValue,
  toStringOrNull,
} from "src/features/admin/screen-shared"

export const toFormValues = (result: BankTransferResult): BankTransferResultFormValues => ({
  userId: toInputValue(result.userId),
  bankTransferInvoiceId: toInputValue(result.bankTransferInvoiceId),
  paymentAt: toDateTimeInputValue(result.paymentAt),
  bankCode: toInputValue(result.bankCode),
  branchCode: toInputValue(result.branchCode),
  accountNumber: toInputValue(result.accountNumber),
  amount: toInputValue(result.amount),
})

export const toRequestBody = (values: BankTransferResultFormValues) => ({
  userId: toStringOrNull(values.userId),
  bankTransferInvoiceId: toStringOrNull(values.bankTransferInvoiceId),
  paymentAt: toDateTimeOrNull(values.paymentAt),
  bankCode: toStringOrNull(values.bankCode),
  branchCode: toStringOrNull(values.branchCode),
  accountNumber: toStringOrNull(values.accountNumber),
  amount: toStringOrNull(values.amount),
})
